import { Component, OnInit } from '@angular/core';
import {AuthService} from "../services/auth.service";

@Component({
    selector: 'app-user-output-url',
    templateUrl: './user-output-url.component.html',
    styleUrls: ['./user-output-url.component.scss'],
    standalone: false
})
export class UserOutputUrlComponent implements OnInit {

  constructor(
    public auth: AuthService,
  ) { }

  ngOnInit(): void {
  }

  getUserOutputUrl() {
    if (!this.auth.user) return '';
    const href = window.location.href;
    return href.substring(0, href.indexOf('/', 8)) + '/user-layer/' + this.auth.user.uid;
  }
}
